export const DefaultGrid = (props: any) => (
  <svg {...props}>
    <path d="M0 0h4v4H0zM6 0h10v4H6zM0 6h4v4H0zM6 6h10v4H6z" />
  </svg>
);

export const TwoByTwo = (props: any) => (
  <svg {...props}>
    <path d="M0 0h4v4H0zM6 0h4v4H6zM0 6h4v4H0zM6 6h4v4H6z" />
  </svg>
);

export const ThreeByTwo = (props: any) => (
  <svg {...props}>
    <path d="M0 0h4v4H0zM6 0h4v4H6zM12 0h4v4h-4zM0 6h4v4H0zM6 6h4v4H6zM12 6h4v4h-4z" />
  </svg>
);

export const FourByTwo = (props: any) => (
  <svg {...props}>
    <path d="M0 0h4v4H0zM6 0h4v4H6zM12 0h4v4h-4zM18 0h4v4h-4zM0 6h4v4H0zM6 6h4v4H6zM12 6h4v4h-4zM18 6h4v4h-4z" />
  </svg>
);
